import { axiosInstance } from "..";

const addTrelloComment = async (id, data) => {
  return new Promise(async (resolve, reject) => {
    axiosInstance
      .post(
        `/internal/pm/addComment/${id}`,data
      )
      .then((res) => {
        if (res.status === 200) {
          return resolve(res);
        }
        return resolve(res);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export default addTrelloComment;
